import { render, staticRenderFns } from "./NewEditableColumn.vue?vue&type=template&id=812480fa&"
import script from "./NewEditableColumn.vue?vue&type=script&lang=js&"
export * from "./NewEditableColumn.vue?vue&type=script&lang=js&"
import style0 from "./NewEditableColumn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports